module.exports = __webpack_public_path__ + "static/media/orso.1260cb42.jpg";